import LoginStatus from './Components/LoginStatus.vue';
import Vue from 'vue';

export async function initLoginBox() {
  const loginElement = $('.js-login-box-header');
  const loginMobileElement = $('.js-login-box-header-mobile');
  const url = loginElement.data('loginStatusUrl');
  const myAccount = loginElement.data('myaccount');
  const isExtranet = loginElement.data('isextranet');
  const myAccountMobile = loginMobileElement.data('myaccount');
  const isExtranetMobile = loginMobileElement.data('isextranet');
  if (!url) {
    return;
  }
  const initialUserData = await $.ajax(url);
  new Vue({
    el: '.js-login-box-header',
    template: '<LoginStatus :myAccount="myAccount" :url="url" :isExtranet="isExtranet" :isMobile="false" :initialUserData="initialUserData"/>',
    data: {url, myAccount, isExtranet, initialUserData},
    components: {LoginStatus},
  });
  new Vue({
    el: '.js-login-box-header-mobile',
    template: '<LoginStatus :myAccount="myAccountMobile" :url="url" :isExtranet="isExtranetMobile" :isMobile="true" :initialUserData="initialUserData"/>',
    data: {url, myAccountMobile, isExtranetMobile, initialUserData},
    components: {LoginStatus},
  });
}
